module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy.c00a0b88.md";